module.exports = "pegasus_template/assets/blocks/tile-layout-12.png";